<template>
  <div class="chips-wrapper" ref="chips-wrapper">
    <div class="chips-container" v-if="!numberOfOverflowedChips">
      <div class="chips" v-for="option in calculatedOptions" :key="option.selectedFieldLabel" @click.stop="">
        <span class="chips__name">{{chipName(option)}}</span>
        <div class="chips__button" @click.stop="deleteFilter(option)"></div>
      </div>
    </div>
    <div class="chips-amount" v-else>{{overflowLabel}}</div>
    <div class="chips chips_test" ref="test-wrapper">
      <span class="chips__name" ref="test"></span>
      <div class="chips__button"></div>
    </div>
    <button class="chips chips__copy-button" v-if="replicable" :class="{'chips__copy-button_disabled': isOptionsAbsent}" @click.stop="$emit('copy')">
      <base-material-design-icon class="chips__copy-icon" icon="copy" />
      Copy
    </button>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'AdvancedChipsBlock',
  mounted () {
    this.calculateWidth()
    window.addEventListener('resize', _.throttle(() => {
      let body = document.getElementsByTagName('body')[ 0 ]
      const style = body.currentStyle || window.getComputedStyle(body)
      if (window.innerWidth < parseFloat(style.maxWidth)) {
        return
      }
      !this.isCalculating && this.calculateWidth()
    }, 100, { trailing: true }), false)
  },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    replicable: {
      type: Boolean,
      default: true
    },
    forceCalculate: {
      type: Boolean,
      default: false
    },
    copyPage: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isCalculating: false,
      numberOfOverflowedChips: 1
    }
  },
  computed: {
    overflowLabel: function () {
      return this.numberOfOverflowedChips === 1 ? `${this.numberOfOverflowedChips} filter applied`
        : `${this.numberOfOverflowedChips} filters applied`
    },
    calculatedOptions () {
      if (!this.numberOfOverflowedChips && !this.isCalculating) {
        return this.options
      } else {
        return []
      }
    },
    isOptionsAbsent () {
      if (this.copyPage) {
        return false
      }
      return !this.options.length
    }
  },
  watch: {
    options () {
      this.$nextTick(this.calculateWidth)
    },
    forceCalculate (value) {
      if (value) {
        this.$nextTick(this.calculateWidth)
      }
    }
  },
  methods: {
    calculateWidth () {
      this.isCalculating = true
      this.numberOfOverflowedChips = 0
      const calculateElementWidth = (item) => {
        testChipName.innerHTML = this.chipName(item)
        return testChipWrapper.offsetWidth + parseFloat(testStyle.marginLeft) + parseFloat(testStyle.marginRight)
      }

      const ref = this.$refs[ 'chips-wrapper' ]
      if (!ref) {
        return
      }
      const buttonWidth = 113
      const allowedWidth = ref.parentNode.offsetWidth - buttonWidth
      const estimatedFilters = []
      const testChipName = this.$refs[ 'test' ]
      const testChipWrapper = this.$refs[ 'test-wrapper' ]
      const testStyle = window.getComputedStyle(testChipWrapper)
      let length = 0
      for (const item of this.options) {
        length += calculateElementWidth(item)
        if (length < allowedWidth) {
          estimatedFilters.push(item)
        } else {
          if (estimatedFilters.length < this.options.length) {
            this.numberOfOverflowedChips = this.options.length
          }
          break
        }
      }
      this.isCalculating = false
      testChipName.innerHTML = ''
    },
    chipName (option) {
      const operator = option.operators.operatorVariants.find(item => item.value === option.selectedOperator)
      return `${option.label} ${operator.label} ${option.selectedFilter.text}`
    },
    deleteFilter (option) {
      this.$emit('delete-option', option)
    }
  }
}
</script>

<style scoped lang="scss">
  .chips {
    padding: 3px 0 3px 12px;
    border-radius: 15px;
    background-color: $rfx-light-blue;
    height: 30px;
    margin-right: 16px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;

    &__name {
      font-size: 12px;
      color: #fff;
      text-transform: lowercase;
      width: 100%;
      @include ellipsis;
    }

    &__button {
      position: relative;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      pointer-events: auto;

      &:before,
      &:after {
        position: absolute;
        right: 12px;
        top: 9px;
        content: " ";
        height: 12px;
        width: 2px;
        background-color: #fff;
      }

      &:before {
        transform: rotate(45deg);
      }

      &:after {
        transform: rotate(-45deg);
      }

      &:hover {
        &:before, &:after {
          background-color: $rfx-silver;
        }
      }
    }

    &_test {
      opacity: 0;
      position: absolute;
      left: 113px; /*button width*/
      width: fit-content;
    }

    &__copy-button {
      background-color: #fff;
      color: $rfx-dark-grey;
      outline: none;
      border: 1px solid $rfx-dark-grey;
      margin-left: auto;
      font-size: 12px;
      width: 82px;
      min-width: 82px;
      text-transform: uppercase;
      padding: 0 15px;

      &_disabled {
        pointer-events: none;
        border-color: $rfx-pale-grey;
        background-color: $rfx-pale-grey;
        opacity: 0.4;
      }

      &:not(&_disabled) {
        &:hover {
          background-color: rgba(40, 74, 255, 0.1);
        }

        &:active {
          color: #fff;
          background-color: $rfx-bright-blue;
        }

      }
    }

    &__copy-icon {
      font-size: 16px;
    }
  }

  .chips-wrapper {
    display: flex;
    margin-left: 10px;
    width: 100%;
    position: relative;
  }

  .chips-container {
    display: flex;
    width: 100%;
    overflow: hidden;
    z-index: 9;
  }

  .chips-amount {
    font-size: 12px;
    color: $rfx-dark-grey;
    display: flex;
    align-items: center;
  }
</style>
